<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="60%">
    <div class="personnel3">
      <el-table :data="list" v-loading='loading' stripe border>
        <el-table-column align='center' label="签到时间" width="180">
          <template slot-scope="scope">
            {{ scope.row.sign_time | timeFormat }}
          </template>
        </el-table-column>
        <el-table-column align='center' prop='customer_name' label="服务对象姓名" width="80"></el-table-column>
        <el-table-column align='center' prop='customer_age' label="年龄" width="80"></el-table-column>
        <el-table-column align='center' label="性别" width="80">
          <template slot-scope="scope">
            {{ scope.row.customer_sex | isSex }}
          </template>
        </el-table-column>
        <el-table-column align='center' prop='customer_phone' label="手机号码" width="120"></el-table-column>
        <el-table-column align='center' label="头像" width="90">
          <template slot-scope="scope">
            <img :src="scope.row.customer_photo_path" style="width: 60px;height: 60px;" alt="">
          </template>
        </el-table-column>
        <el-table-column align='center' prop='sign_address' label="签到地址" show-overflow-tooltip></el-table-column>
        <el-table-column align='center' prop='customer_current_address' label="服务对象居住地址" show-overflow-tooltip>
        </el-table-column>
      </el-table>
      <el-pagination style="margin: 30px auto;text-align: center;" v-if="query.total > 0" @size-change="sizeChange"
        @current-change="pageChange" :current-page="query.page" :page-size="query.page_limit"
        layout="total, prev, pager, next, jumper" :total="query.total">
      </el-pagination>
    </div>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import userInfoAPI from '@/api/api';
  export default {
    name: 'signList',
    data() {
      return {
        title: '',
        dialogVisible: false,
        list: [],
        loading: true,
        query: {
          user_id: '',
          page_limit: 10,
          page: 1,
          total: 0
        }
      }
    },
    methods: {
      show(row) {
        if (row) {
          this.title = '“ ' + row.user_name + ' ” 的签到记录'
          this.query.page = 1
          this.query.user_id = row.user_id
          this.list = []
          this.loading = true
          this.getList()
          this.dialogVisible = true
        }
      },
      pageChange(val) {
        this.loading = true;
        this.query.page = val
        this.getList();
      },
      sizeChange(val) {
        this.loading = true;
        this.query.page_limit = val
        this.getList();
      },
      getList() {
        userInfoAPI.serviceUserSignList(this.query).then(res => {
          if (res.data.code == 0) {
            this.list = res.data.data.list || []
            this.query.total = res.data.data.page.count || 0
          }
          this.loading = false
        })
      }
    }
  }
</script>

<style>
</style>
